{
    "tenants": {
        "title": "Hyresgäster",
		"addTenant": "Lägg till hyresgäst",
		"companyName": "Företagsnamn",
		"tenantAlias": "Hyresgästalias",
		"email": "E-post",
		"tier": "Nivå",
		"status": "Status",
		"type": "Typ",
		"address": "Adress",
		"phone": "Telefon",
		"adminEmail": "Administratörs e-postadress",
		"billingEmail": "Fakturerings-e-post",
		"tenantType": "Hyresgästtyp",
		"tenantApps": "Hyresgästappar",
		"tenantLabel": "Hyresgäst",
		"smsMfa": "SMS MFA",
		"newTenant": "Ny hyresgäst",
		"editTenant": "Redigera hyresgäst",
        "active": "Aktiv",
		"inactive": "Inaktiv",
		"enabled": "Aktiverad",
		"disabled": "Inaktiverad",
        "tenantUsers": "Hyresgästanvändare",
        "validation": {
            "companyNameRequired": "Företagsnamn krävs",
            "addressRequired": "Adress krävs",
            "addressMaxLength": "Adressen får inte överstiga 100 tecken",
            "phoneRequired": "Telefonnummer krävs",
            "phoneInvalid": "Ange ett giltigt telefonnummer",
            "adminEmailRequired": "Administratörens e-post krävs",
            "adminEmailInvalid": "Ange en giltig administratörs-e-post",
            "billingEmailInvalid": "Ange en giltig fakturerings-e-post",
            "billingEmailRequired": "Fakturerings-e-post krävs",
			"tierRequired": "Nivå krävs",
			"tenantTypeRequired": "Hyresgästtyp krävs",
			"dedicatedIpHostnameRequired": "Värdnamn krävs när dedikerad IP är aktiverad",
			"dedicatedIpHostnameInvalid": "Ange ett giltigt värdnamn (t.ex. eu-west-dedicated-02.quotaguard.com)",
			"dedicatedIpEgressIpRequired": "Utgående IP krävs när dedikerad IP är aktiverad",
			"dedicatedIpEgressIpInvalid": "Ange en giltig IPv4-adress (t.ex. 192.168.1.1)",
			"dedicatedIpUsernameRequired": "Användarnamn krävs när dedikerad IP är aktiverad",
			"dedicatedIpPasswordRequired": "Lösenord krävs när dedikerad IP är aktiverad",
			"dedicatedIpPortRequired": "Port krävs när dedikerad IP är aktiverad",
			"dedicatedIpPortInvalid": "Ange ett giltigt portnummer (1–65535)",
			"dedicatedIpProtocolRequired": "Protokoll krävs",
			"dedicatedIpProtocolDuplicate": "Protokoll måste vara unikt för varje port"
        },
		"options": {
			"manageTenant": "Hantera hyresgäst",
			"manageTenantUsers": "Hantera hyresgästanvändare",
			"promoteToAdmin": "Befordra till Live Admin",
			"adminRoleNoActions": "Administratörsroll — inga åtgärder tillgängliga",
			"reindexEntities": "Omindexera entiteter"
		},
		"messages": {
            "loadError": "Fel vid inläsning av hyresgästdata",
			"deactivateTenantConfirmation": "Är du säker på att du vill inaktivera hyresgästen '{tenantName}'?",
			"statusUpdateSuccess": "Hyresgäststatus uppdaterades framgångsrikt",
			"statusUpdateError": "Fel vid uppdatering av hyresgäststatus",
			"saveSuccess": "Hyresgästuppgifter sparas. Detta kan ta en stund…",
			"saveError": "Fel vid sparande av hyresgästuppgifter",
			"tenantUserGroupUpdated": "Användargrupp uppdaterad framgångsrikt",
			"tenantUserGroupUpdateError": "Fel vid uppdatering av användargrupp",
            "confirmPromoteToAdmin": "Är du säker på att du vill befordra {user} till Admin?",
			"reindexSuccess": "Omindexering startad för {count} entiteter",
			"reindexError": "Fel vid start av omindexering"
		},
		"reindex": {
			"title": "Omindexera entiteter",
			"description": "Välj en entitetstyp att omindexera för hyresgästen '{tenantName}'.",
			"selectEntity": "Välj en entitet",
			"confirm": "Omindexera"
		},
		"dedicatedIp": {
			"title": "Dedikerade IP-adresser",
			"enable": "Använd dedikerad IP",
			"proxyHostname": "Proxy-värdnamn",
			"port": "Port",
			"listeningPorts": "Lyssningsportar",
			"selectService": "Välj protokoll",
			"username": "Användarnamn",
			"usernamePlaceholder": "proxy-username",
			"password": "Lösenord",
			"passwordPlaceholder": "••••••••",
			"passwordSet": "Lösenord är angivet ✓",
			"passwordChangePlaceholder": "Lämna tomt för att behålla befintligt lösenord",
			"egressIp1": "Utgående IP 1",
			"egressIp2": "Utgående IP 2"
		},
		"tenantTypes": {
			"SYSADMIN": "Live Admin",
			"TENANT": "Hyresgäst Admin"
		},
		"tiers": {
			"FREE": "Gratis",
			"ENTERPRISE": "Företags",
			"PRO": "Pro"
		},
		"resource": {
			"tenant": "Hyresgäst"
		}
    }
}
